<template>
  <div
    class="the-nav-bar shadow-md transition-transform"
    testek="the-navbar"
    :class="IsExpandSibar ? 'the-nav-bar' : 'the-nav-min'"
  >
    <div class="navbar-header" :class="IsExpandSibar ? 'p-5' : 'p-5 pl-4 flex items-center'">
      <div class="flex justify-between items-center">
        <div
          class="logo-testek h-12 w-20 cursor-pointer"
          @click="backHome"
          v-if="IsExpandSibar"
        ></div>
        <div
          class="icon-24 icon-navbar cursor-pointer"
          @click="clickActionNavbar"
        ></div>
      </div>
    </div>
    <div class="menus" :class="IsExpandSibar ? 'mt-4 pl-3 pr-3' : ''">
      <div
        class="menu flex items-center cursor-pointer h-12 w-full p-2 pl-4 hover:bg-gray-100 rounded-lg"
        v-for="(menu, index) in menus"
        :key="index"
        @click="changeMenu(menu)"
        :class="menuActive.key == menu.key ? 'menu-active text-white' : ''"
      >
        <div class="flex items-center">
          <div
            :class="[
              menuActive.key == menu.key
                ? `${menu.icon}-active`
                : `${menu.icon}`,
              IsExpandSibar ? 'mr-6' : '',
            ]"
          ></div>
          <div v-if="IsExpandSibar">{{ menu.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "TheNavBar",
  data() {
    return {
      menus: [],
      selectedKeys: [1],
      menuActive: {},
      lang: "",
    };
  },
  computed: {
    ...mapGetters(["IsExpandSibar"]),
  },
  created() {
    const me = this;
    me.lang = me.$commonFunc.getLanguageToCached();
    me.$i18n.locale = me.lang;
    me.initDataStatic();
    //check router
    me.checkRouter();

    this.$emitter.on("MenuActive", me.checkRouter);
    this.$emitter.on("LoadLanguage", me.initDataStatic);
  },
  beforeDestroy() {
    this.$emitter.off("MenuActive", this.checkRouter);
    this.$emitter.off("LoadLanguage", this.initDataStatic);
  },
  methods: {
    ...mapMutations(["updateIsExpandSibar"]),
    checkRouter(payload) {
      const me = this;
      let routePath = me.$route.path;
      if (payload && payload.router) {
        routePath = payload.router;
      }
      const menu = me.menus.find((menu) => menu.router === routePath);
      if (menu) {
        me.menuActive = menu;
      } else {
        console.error("Invalid route:", routePath);
      }
    },
    initDataStatic() {
      const me = this;
      me.menus = [
        {
          key: 0,
          name: "Dashboard",
          title: me.$t("i18nCommon.Dashboard"),
          router: "/dashboard",
          icon: "icon-24 icon-dashboard",
        },
        //product
        {
          key: 2,
          name: "Product",
          title: me.$t("i18nCommon.Product"),
          router: "/product",
          icon: "icon-24 icon-product",
        },
        //category
        {
          key: 3,
          name: "Category",
          title: me.$t("i18nCommon.Category"),
          router: "/category",
          icon: "icon-24 icon-category",
        },
        //supplier
        {
          key: 4,
          name: "Supplier",
          title: me.$t("i18nCommon.Supplier"),
          router: "/supplier",
          icon: "icon-24 icon-supplier",
        },
        //order
        {
          key: 5,
          name: "Order",
          title: me.$t("i18nCommon.Order"),
          router: "/order",
          icon: "icon-24 icon-order",
        },
        //customer
        {
          key: 6,
          name: "Customer",
          title: me.$t("i18nCommon.Customer"),
          router: "/customer",
          icon: "icon-24 icon-customer",
        },
        //shipper
        // {
        //   key: 7,
        //   name: "Shipper",
        //   title: me.$t("i18nCommon.Shipper"),
        //   router: "/shipper",
        //   icon: "icon-24 icon-shipper",
        // },
        //saleEmployee
        {
          key: 8,
          name: "SaleEmployee",
          title: me.$t("i18nCommon.SaleEmployee"),
          router: "/sale-employee",
          icon: "icon-24 icon-sale-employee",
        },
        {
          key: 9,
          name: "User",
          title: me.$t("i18nCommon.User"),
          router: "/user-manager",
          icon: "icon-24 icon-user-nav",
        },
        //help support
        // {
        //   key: 9,
        //   name: "HelpSupport",
        //   title: me.$t("i18nCommon.HelpSupport"),
        //   router: "/help-support",
        //   icon: "icon-24 icon-help-support",
        // },
        // //setting
        // {
        //   key: 10,
        //   name: "Setting",
        //   title: me.$t("i18nCommon.Setting"),
        //   router: "/setting",
        //   icon: "icon-24 icon-setting",
        // },
        // //about me
        // {
        //   key: 11,
        //   name: "AboutMe",
        //   title: me.$t("i18nCommon.AboutMe"),
        //   router: "/about-me",
        //   icon: "icon-24 icon-about-me",
        // },
      ];
    },
    changeMenu(menu) {
      const me = this;
      me.menuActive = menu;
      if (me.menuActive) {
        me.$router.push(me.menuActive.router);
      }
    },
    backHome() {
      const me = this;
      me.$router.push("/dashboard");
      me.menuActive = me.menus[0];
    },

    clickActionNavbar() {
      this.updateIsExpandSibar(!this.IsExpandSibar);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/contents/scss/layout/TheNavBar.scss");
</style>
